import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FaArrowLeft, FaEnvelope } from 'react-icons/fa';
import api from '../../utils/api.service';
import { ENDPOINTS } from '../../utils/api-config';
import './Login.css';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await api.post(ENDPOINTS.AUTH.FORGOT_PASSWORD, { email });
      setSuccess(true);
      
      // Small delay before navigating to verify OTP
      setTimeout(() => {
        navigate('/verify-otp', { state: { email } });
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to send OTP. Please ensure the email is correct.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="login-illustration">
          <div className="illustration-overlay">
            <div className="floating-circle circle-1"></div>
            <div className="floating-circle circle-2"></div>
            <div className="floating-circle circle-3"></div>
          </div>
          <div className="illustration-content">
            <div className="silhouette-group">
              <div className="silhouette parent"></div>
              <div className="silhouette child"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="login-right">
        <div className="login-form-container">
          <div className="login-header">
            <div className="brand-logo">
              <div className="brand-logo-image-container">
                <img src="/logo192.png" alt="TinyCare Logo" className="brand-logo-img" />
              </div>
              <span className="brand-text">TinyCare</span>
            </div>
          </div>

          <div className="auth-card">
            <Link to="/login" className="back-link">
              <FaArrowLeft /> Back to Login
            </Link>

            <h2 className="form-title">Forgot Password?</h2>
            <p className="form-subtitle">
              Enter your email address and we'll send you a 6-digit code to reset your password.
            </p>

            {success ? (
              <div className="success-message">
                <p>OTP has been sent to your email! Redirecting...</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="login-form">
                <div className="form-group">
                  <label htmlFor="email">Email address</label>
                  <div className="input-with-icon">
                    <FaEnvelope className="input-icon" />
                    <input
                      type="email"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="admin@tinycare.com"
                      required
                    />
                  </div>
                </div>

                {error && <div className="error-message">{error}</div>}

                <button type="submit" className="btn-signin" disabled={loading}>
                  {loading ? 'Sending code...' : 'Send Reset Code'}
                </button>
              </form>
            )}
          </div>

          <div className="login-footer">
            <p>© TinyCare. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
